<template>
  <div class="frisbuy-picture-sticker">
    <img
      :src="getDomainSubstitute(sticker.pictureUrl)"
      @error="errorImageHandler"
    />
  </div>
</template>

<style scoped lang="scss">
.frisbuy-picture-sticker {
  pointer-events: none;

  width: 100% !important;

  & > img {
    width: 100%;
  }
}
</style>

<script>
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  props: {
    sticker: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    getDomainSubstitute(srcUrl) {
      return DomainSubstitute(srcUrl);
    },

    errorImageHandler(e) {
      MediaCatcher(e, 2, widgetTypes.STORY);
    },
  },
};
</script>
